import { Api } from "api";
import { LocationUsersListRequest } from "types/location-users-type";

// Base path for location service endpoints
// Location service endpoints are at /location_service/v1/monitoring/*
const LOCATION_SERVICE_PREFIX = "/location_service/v1";

// Get monitoring dashboard - single endpoint that returns all metrics
export const getMonitoringDashboard = async () => {
  const res = await Api.get(`${LOCATION_SERVICE_PREFIX}/monitoring/dashboard`);
  return res.data;
};

// Get users list with filters and pagination
export const getLocationUsers = async (params?: LocationUsersListRequest) => {
  const queryParams = new URLSearchParams();
  
  if (params?.inside_factory !== undefined) {
    queryParams.append("inside_factory", params.inside_factory.toString());
  }
  if (params?.location_active !== undefined) {
    queryParams.append("location_active", params.location_active.toString());
  }
  if (params?.waiting_location !== undefined) {
    queryParams.append("waiting_location", params.waiting_location.toString());
  }
  if (params?.limit !== undefined) {
    // Validate limit (max 100 per API spec)
    const limit = Math.min(Math.max(1, params.limit), 100);
    queryParams.append("limit", limit.toString());
  }
  if (params?.offset !== undefined && params.offset >= 0) {
    queryParams.append("offset", params.offset.toString());
  }

  const queryString = queryParams.toString();
  const url = `${LOCATION_SERVICE_PREFIX}/users${queryString ? `?${queryString}` : ""}`;
  
  const res = await Api.get(url);
  return res.data;
};
